import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { O_AUTH_CLIENT_ID } from './api/static.data.pnp';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import SocketProvider from './providers/SocketProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={O_AUTH_CLIENT_ID}>
      <SocketProvider>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </SocketProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
